export interface AggregateApi {
	summary: any;
}

export interface SubReportApi {
	group_by_type: string;
	group_by_value: any;
	aggregate: any;
	compare_aggregate: any;
	sub_report: SubReportApi[];
}

export interface ReportApi {
	reports: SubReportApi[];
}

export enum RenderColumnInAreaType {
	GROUP,
	SUMMARY,
}

export interface RenderColumnInArea {
	rowType: RenderColumnInAreaType;
	columnType: RenderColumnInAreaType;
}

export interface ReportConfigColumn {
	id: string;
	name: string;
	render?: (propertyValue: any, fullAggregateObject: Record<string, any>, renderArea: RenderColumnInArea) => any;
	renderCsv?: (propertyValue: any, fullAggregateObject: Record<string, any>, renderArea: RenderColumnInArea) => any;
	renderView?: (
		propertyValue: any,
		fullAggregateObject: Record<string, any>,
		renderArea: RenderColumnInArea,
		renderPDF?: boolean
	) => any;
	isDate?: boolean;
}

export interface ReportGroup {
	id: string;
	checked: boolean;
}
